import react from "react";
import logo from '../../../resources/img/logo-2.png';

function Loading() {

    return  <div className="contenedor-loading">
                <span className="spinner-border spinner-border-sm loading-spinner" role="status" aria-hidden="true"></span>
            </div>;
}
export default Loading;